exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-80 {\n  width: 80%; }\n\n.leftContent {\n  margin-left: 0px; }\n\n.selectOption {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.form-group {\n  margin-left: 0.5rem;\n  width: 50%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/free-float/free-float.component.scss
// module id = ../../../../../src/app/securities-level/free-float/free-float.component.scss
// module chunks = main